import { AlloyButton } from 'cat-ecommerce-alloy';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getDealerCustomerStores } from '@app/store/dealer-customer/actions';
import {
  ERROR_DOMAIN,
  ERROR_PATH,
  FEEDBACK_TYPES
} from '@app/constants/errorConstants';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import { useFormikContext } from 'formik';
import { getDealerAssociations } from '@app/store/dealer-association/actions';
import ExceptionFeedback from '@app/components/common/Exception/ExceptionFeedback';
import { getCookie } from '@app/utils';

const EditOrderInformationFormExceptionFeedback = ({
  dealerAssociationCallError,
  dealerCustomerServiceCallError,
  orderInformationError,
  onRetrySetOrderinformation
}) => {
  const [t] = useTranslation();
  const referenceId = getCookie('X-Cat-Pcc-Session-Id');
  const dispatch = useDispatch();
  const errorSelector = state =>
    state.errors[ERROR_DOMAIN.CART]?.[ERROR_PATH.EDIT_ORDER_INFORMATION];
  const errorPath = {
    domain: ERROR_DOMAIN.CART,
    path: ERROR_PATH.EDIT_ORDER_INFORMATION
  };
  const { values } = useFormikContext();

  const customerNumber = values.customerNumber?.value;

  const onDealerCustomerTryAgain = () =>
    dispatch(getDealerCustomerStores({ customerNumber, errorPath }));

  const onDealerAssociationTryAgain = () => dispatch(getDealerAssociations());

  return (
    <div>
      <ExceptionFeedbackBySelector
        className="mb-2 py-1"
        messageClassName={'mb-1'}
        selector={errorSelector}
      >
        <p>
          {t('SHOPPING_CART_REFERENCE_ID')}: {referenceId}
        </p>
        {dealerCustomerServiceCallError ? (
          <AlloyButton
            buttonType="secondary"
            className="mt-2 me-4"
            size="small"
            onClick={onDealerCustomerTryAgain}
          >
            {t('TRY_AGAIN')}
          </AlloyButton>
        ) : null}
        {orderInformationError ? (
          <AlloyButton
            buttonType="secondary"
            className="mt-2 me-4"
            size="small"
            onClick={onRetrySetOrderinformation}
          >
            {t('TRY_AGAIN')}
          </AlloyButton>
        ) : null}
      </ExceptionFeedbackBySelector>
      {dealerAssociationCallError && (
        <ExceptionFeedback
          className="mb-2 pt-1 pb-2"
          preventScroll
          title={t('UNKNOWN_ERROR_TITLE')}
          type={FEEDBACK_TYPES.WARNING}
        >
          <p className="mb-1">{t('LOAD_ACCOUNTS_ERROR')}</p>
          <AlloyButton
            buttonType="secondary"
            className="mt-2 me-4"
            size="small"
            onClick={onDealerAssociationTryAgain}
          >
            {t('TRY_AGAIN')}
          </AlloyButton>
        </ExceptionFeedback>
      )}
    </div>
  );
};

EditOrderInformationFormExceptionFeedback.propTypes = {
  dealerAssociationCallError: PropTypes.bool,
  dealerCustomerServiceCallError: PropTypes.bool,
  orderInformationError: PropTypes.bool,
  onRetrySetOrderinformation: PropTypes.func
};

export default EditOrderInformationFormExceptionFeedback;
